module.exports = __webpack_public_path__ + "img/Card.a9f70387.webp";